import { NavItem } from '@app/components/layout/sidenav/link/NavItem';
import { useUiStore } from '@app/core/ui/stores/ui.store';
import { ViewSidebar } from '@mui/icons-material';
import { defineMessage, useIntl } from 'react-intl';
import { useSidenavContext } from '../SidenavContext';

const collapseLabelMessage = defineMessage({
  id: 'core.sidenav.collapseTooltip',
  defaultMessage: 'Cerrar menú',
});

const expandLabelMessage = defineMessage({
  id: 'core.sidenav.expandTooltip',
  defaultMessage: 'Abrir menú',
});

/** Toggles sidenav expanded/collapsed state using the UI store. No props needed. */
export const NavStateToggler = () => {
  const { collapsed } = useSidenavContext();
  const toggleSidenav = useUiStore((state) => state.toggleSidenav);
  const $t = useIntl().formatMessage;
  const label = collapsed ? $t(expandLabelMessage) : $t(collapseLabelMessage);

  return (
    <NavItem
      to="#"
      isActive={() => false}
      onClick={(evt) => {
        evt.preventDefault();
        toggleSidenav();
      }}
      icon={<ViewSidebar fontSize="small" />}
    >
      <span
        style={{
          fontSize: 'small',
          textTransform: 'none',
          fontWeight: 400,
          opacity: 0.7,
        }}
      >
        {label}
      </span>
    </NavItem>
  );
};
